module.exports = __webpack_public_path__ + "static/media/Half_W_Art_Img_02.d17fb32a.jpg";